import React, { Fragment } from 'react';

import InputAdornment from '@material-ui/core/InputAdornment';

import EditForm from './_EditForm';
import { FancyDateTime, TextArea, ChipSelect, NumberField } from '../Forms'

class EditForm_BottleFeed extends EditForm {

  constructor(props, context) {
    super(props, context, 'bottle-feed');
  }

  state = {
    start: EditForm.getField('data.start')(this.props.record),
    end: EditForm.getField('data.end')(this.props.record),
    type: EditForm.getField('data.type')(this.props.record),
    volume: EditForm.getField('data.volume')(this.props.record),
    notes: EditForm.getField('data.notes')(this.props.record),
  }

  buildRecordData = () => {
    const { start, end, type, volume, notes } = this.state;

    return {
      start: start || null,
      end: end || null,
      type,
      volume,
      notes,
    };
  }

  renderTopicFields = () => {
    const { start, end, type, volume, notes } = this.state;

    return (
      <Fragment>

        <FancyDateTime
          label="Start"
          margin="normal"
          value={start}
          onChange={this.onChange('start')}
        />

        <FancyDateTime
          label="End"
          margin="normal"
          value={end}
          onChange={this.onChange('end')}
        />

        <ChipSelect
          label="Type"
          margin="normal"
          value={type || ''}
          onChange={this.onChange('type')}
          options={[
            'Breast milk',
            'Formula',
          ]}
        />

        <NumberField
          label="Volume"
          InputProps={{
            endAdornment: <InputAdornment>ml</InputAdornment>
          }}
          value={volume || ''}
          onChange={this.onDomChange('volume')}
        />

        <TextArea
          label="Notes"
          margin="normal"
          rowsMax={8}
          value={notes || ''}
          onChange={this.onDomChange('notes')}
        />
        
      </Fragment>
    );
  }

}
export default EditForm_BottleFeed;
